import React from 'react';
import { dynamic } from 'umi';

/**
 * AgentVegaChart 的懒加载版本。
 * dynamic() loader 仅做动态 import，不形成静态依赖，
 * 确保 AgentVegaChart 主体代码保持在独立异步 chunk 中。
 */
export const AgentVegaChartAsync = dynamic({
  loader: async () => {
    const { default: AgentVegaChart } = await import(/* webpackChunkName: "agent-vega-chart" */ '.');
    return AgentVegaChart;
  },
  loading: () => <div style={{ height: 300, width: '100%' }} />,
});
